import { render, staticRenderFns } from "./NotificationPreviewList.vue?vue&type=template&id=9ffb2d38&"
import script from "./NotificationPreviewList.vue?vue&type=script&lang=js&"
export * from "./NotificationPreviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports